import { En } from "../lang/en.js";
const translationsLanguages = {
  en: En
};
const addTranslation = (langCode, languageDictionary) => {
  translationsLanguages[langCode] = languageDictionary;
};
const getBrowserLanguage = () => {
  var _a;
  return ((_a = globalThis.navigator) == null ? void 0 : _a.language.split("-")[0]) || "en";
};
const t = (key, variables = {}) => {
  var _a;
  const result = ((_a = translationsLanguages[getBrowserLanguage()]) == null ? void 0 : _a[key]) || En[key];
  return result.replace(
    /\{(\w+)\}/g,
    (_, varName) => variables[varName] !== void 0 ? String(variables[varName]) : `{${varName}}`
  );
};
export {
  addTranslation,
  t
};
